export const DEFAULT_LOCALE = "en";
/**
 * The `cropId` a video carries: it is delivered as uploaded, so the thing being
 * named is the original itself rather than any rendition of it.
 */
export const ORIGINAL_RENDITION = "original";
/**
 * Does a stored reference belong to this asset?
 *
 * The question needs asking because a reference is indexed under its CROP alone,
 * and a `cropId` is only `{w}x{h}` — so one partition holds every photograph in
 * the library that was ever framed to that size. The `assetId` on the ref is the
 * only thing that tells them apart.
 *
 * A ref that names NO asset is kept, with one exception. It cannot be attributed
 * either way, and for a `{w}x{h}` ref it at least names a real framing. But
 * {@link ORIGINAL_RENDITION} resolves to `/media/originals/{assetId}` and to
 * nothing else, so an unattributed one names no file at all — and its partition
 * holds every unframed placement in the library, which would otherwise attach to
 * every asset at once.
 */
export function refBelongsToAsset(ref, assetId) {
    if (!assetId)
        return true;
    if (ref.assetId)
        return ref.assetId === assetId;
    return ref.cropId !== ORIGINAL_RENDITION;
}
export const EMPTY_RICH_TEXT_DOCUMENT = {
    type: "doc",
    content: [{ type: "paragraph" }],
};
/**
 * A fresh empty document, safe to mutate.
 *
 * EMPTY_RICH_TEXT_DOCUMENT is a shared value, so anything that stores it needs
 * its own copy or two slots end up aliasing one document. Call this instead of
 * cloning the constant at each site.
 */
export function emptyRichTextDocument() {
    return { type: "doc", content: [{ type: "paragraph" }] };
}
/**
 * The Open Graph card's fixed output size — 1.91:1, the shape every social
 * platform crops a share preview to.
 *
 * One number, read by the CMS's share-image picker (what it frames to) and by
 * the public page's `og:image:width`/`height` (what it declares). A slot size
 * the two could disagree about would publish a lie about the image served.
 */
export const OG_IMAGE_SLOT = { width: 1200, height: 630 };
//# sourceMappingURL=page.js.map